"use client";

import type { UseCaseGridItem } from "@/components/sections/shared/use-cases-grid";
import {
  BrandVisual,
  MarketVisual,
  ScrapingVisual,
  SeoVisual,
} from "@/components/sections/shared/use-cases-grid/card-visuals";

/* Four mobile-specific use cases on the shared bento. Two wide cards + two
   singles fill a clean 3-column grid (wide + single, single + wide). General
   scraping, price monitoring, and AI data collection live on the residential
   page — residential is usually the better value for those jobs. */
export const MOBILE_USE_CASES: UseCaseGridItem[] = [
  {
    id: "ad-verification",
    label: "Mobile Ad Verification",
    headline: "Check localized ads exactly as mobile users see them.",
    description:
      "Check public ads and landing pages from available mobile locations and networks by selecting city and session behavior per access point.",
    href: "/use-cases/ad-verification/",
    Visual: BrandVisual,
    span: "wide",
  },
  {
    id: "seo-testing",
    label: "Mobile SERP Monitoring",
    headline: "Track mobile SERPs from any city.",
    description:
      "Measure localized mobile search results using city-specific mobile exits, without buying a fixed number of proxies.",
    href: "/use-cases/seo-monitoring",
    Visual: SeoVisual,
  },
  {
    id: "localized-content-testing",
    label: "Location & Network Testing",
    headline: "See every regional variation of your pages.",
    description:
      "Validate public content, redirects, pricing, and regional experiences from mobile network origins. Lock a city, hold a sticky session, or rotate on demand.",
    href: "/use-cases/localized-testing/",
    Visual: MarketVisual,
  },
  {
    id: "web-scraping",
    label: "Mobile-Web Data Collection",
    headline: "Collect public data when the target expects a mobile IP.",
    description:
      "Use random IP mode for a fresh exit on every connection, or hold a sticky session for a stable, known IP. For high-volume general scraping, residential proxies are usually the better value.",
    href: "/use-cases/web-scraping",
    Visual: ScrapingVisual,
    span: "wide",
  },
];
